import React from "react";
import { LogMessage } from "~/components/shared/Log";
import Spinner from "~/components/shared/Spinner";

export function LoadingMessage() {
  return (
    <LogMessage>
      <div className="flex items-center">
        <Spinner size="16px" className="mr-2" />
        Loading agent logs...
      </div>
    </LogMessage>
  );
}

export function LoadingMoreMessage() {
  return (
    <LogMessage>
      <div className="flex items-center justify-center py-4">
        <Spinner size="16px" className="mr-2" />
        Loading more logs...
      </div>
    </LogMessage>
  );
}

export function NoLogsMessage() {
  return <LogMessage>No agent logs available for this job.</LogMessage>;
}

export function NotHostedMessage() {
  return <LogMessage>Agent logs are only available for hosted agents.</LogMessage>;
}

export function ErrorMessage({ error }: { error: string }) {
  // Try to parse JSON error, fallback to string
  let errorMessage: string;
  try {
    const errorData = JSON.parse(error);
    errorMessage = errorData.error || error;
  } catch {
    errorMessage = error;
  }

  return (
    <LogMessage>
      <div className="text-red-600">
        <strong>Error loading agent logs:</strong> {errorMessage}
      </div>
    </LogMessage>
  );
}
